'use client'

import { cn } from '~/utils/cn'
import { IconProps } from '../Icons'

export const IconTaloflow = ({
  className,
  revertOnHover = false,
}: IconProps & { revertOnHover?: boolean }) => (
  <svg
    className={cn(
      'fill-current',
      {
        'text-primary-500': !className,
        'revert-arrow': revertOnHover,
      },
      className
    )}
    viewBox="0 0 62 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      className="arrow"
      d="M15.0009 4.03448L18.9785 0L31.7953 13L18.9785 26L15.0009 21.9655L21.0312 15.849H0V10.1434H21.0237L15.0009 4.03448Z"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M62 13C62 20.1797 56.1934 26 49.0306 26C41.8678 26 36.0612 20.1797 36.0612 13C36.0612 5.8203 41.8678 0 49.0306 0C56.1934 0 62 5.8203 62 13ZM56.5949 13C56.5949 17.0269 53.3085 20.475 49.0306 20.475C44.7527 20.475 41.4663 17.0269 41.4663 13C41.4663 8.97314 44.7527 5.525 49.0306 5.525C53.3085 5.525 56.5949 8.97314 56.5949 13Z"
    />
  </svg>
)
